export const quickPromptsList = [
  { key: 'Blues', value: 'blues' },
  { key: 'Drums', value: 'drums' },
  { key: 'Bass', value: 'bass' },
  { key: 'Emo-Pop', value: 'emo-pop' },
  { key: 'Swing', value: 'swing' },
  { key: 'Vibrant', value: 'vibrant' },
  { key: 'Rhythmic', value: 'rhythmic' },
  { key: 'Hopeful', value: 'hopeful' },
  { key: 'Gritty', value: 'gritty' },
  { key: 'Bright', value: 'bright' },
  { key: 'Pop-Future', value: 'pop-future' },
  { key: 'Energetic', value: 'energetic' },
  { key: 'Synths', value: 'synths' },
  { key: 'Tribal', value: 'tribal' },
  { key: 'Tribal Drums', value: 'tribal drums' },
  { key: 'Driving ', value: 'driving ' },
  { key: 'Hip-Hop Beat', value: 'hip-hop beat' },
  { key: 'Funk', value: 'funk' },
  { key: 'Edgy', value: 'edgy' },
  { key: 'Twang', value: 'twang' },
  { key: 'Rock', value: 'rock' },
  { key: 'Guitar Riffs', value: 'guitar riffs' },
  { key: 'Euphoric', value: 'euphoric' },
  { key: 'Ambient', value: 'ambient' },
  { key: 'Indie', value: 'indie' },
  { key: 'Acoustic', value: 'acoustic' },
  { key: 'Resonant ', value: 'resonant ' },
  { key: 'Ethereal', value: 'ethereal' },
  { key: 'Smooth', value: 'smooth' },
  { key: 'Rich', value: 'rich' },
  { key: 'Electric', value: 'electric' },
  { key: 'Symphonic', value: 'symphonic' },
  { key: 'Orchestral', value: 'orchestral' },
  { key: 'Dance', value: 'dance' },
  { key: 'EDM', value: 'EDM' },
  { key: 'Country', value: 'country' },
  { key: 'Psychedelic', value: 'psychedelic' },
  { key: 'Electronic', value: 'electronic' },
  { key: 'Classical', value: 'classical' },
  { key: 'Hypnotic', value: 'hypnotic' },
  { key: 'Hip-Hop', value: 'hip-hop' },
  { key: 'Groovy', value: 'groovy' },
  { key: 'Bouncy', value: 'bouncy' },
  { key: 'Staccato', value: 'staccato' },
  { key: 'Pulsating', value: 'pulsating' },
  { key: 'Syncopated', value: 'syncopated' },
  { key: 'Slow', value: 'slow' },
  { key: 'Fast-Paced', value: 'fast-paced' },
  { key: 'Steady', value: 'steady' },
  { key: 'Jazz', value: 'jazz' },
  { key: 'Reggae', value: 'reggae' },
  { key: 'High-Energy', value: 'high-energy' },
  { key: 'Lively', value: 'lively' },
  { key: 'Retro', value: 'retro' },
  { key: 'Tranquil ', value: 'tranquil ' },
  { key: 'Lo-Fi', value: 'lo-fi' },
  { key: 'Mysterious', value: 'mysterious' },
  { key: 'Serene', value: 'serene' },
  { key: 'Tense', value: 'tense' },
  { key: 'Passionate', value: 'passionate' },
  { key: 'Intense', value: 'intense' },
  { key: 'Piano', value: 'piano' },
];
